import React, { useEffect, useState } from 'react'

interface Snowflake {
  id: number
  left: number
  animationDuration: number
  size: number
  delay: number
}

const Snowfall: React.FC = () => {
  const [snowflakes, setSnowflakes] = useState<Snowflake[]>([])

  useEffect(() => {
    // 生成隨機雪花
    const flakes: Snowflake[] = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: Math.random() * 100, // 0-100%
      animationDuration: 3 + Math.random() * 7, // 3-10秒
      size: 2 + Math.random() * 4, // 2-6px
      delay: Math.random() * 5, // 0-5秒延遲
    }))
    setSnowflakes(flakes)
  }, [])

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="absolute animate-snowfall"
          style={{
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.delay}s`,
          }}
        >
          <div className="w-full h-full rounded-full bg-white opacity-80 shadow-sm" />
        </div>
      ))}
      
      <style>{`
        @keyframes snowfall {
          0% {
            transform: translateY(-10px) translateX(0);
            opacity: 0;
          }
          10% {
            opacity: 0.8;
          }
          90% {
            opacity: 0.8;
          }
          100% {
            transform: translateY(100vh) translateX(50px);
            opacity: 0;
          }
        }
        
        .animate-snowfall {
          animation: snowfall linear infinite;
        }
      `}</style>
    </div>
  )
}

export default Snowfall
